import {Component, provide, ComponentRef, PLATFORM_DIRECTIVES, enableProdMode} from "@angular/core";
import {Title} from "@angular/platform-browser";
import {bootstrap} from "@angular/platform-browser-dynamic";
import {
  RouteConfig,
  ROUTER_PROVIDERS,
  ROUTER_DIRECTIVES,
} from "@angular/router-deprecated";
import {LocationStrategy, HashLocationStrategy} from "@angular/common";
import {HTTP_PROVIDERS} from "@angular/http";
import {MdToolbar} from "@angular2-material/toolbar";
import {UseCaseContainer, UseCaseContent, UseCaseSource} from "./shared/usecase/component";
import {ModuleRoot} from "./shared/moduleroot/component";
import {CoreRoot} from "./core/root.component";
import {CommonRoot} from "./common/root.component";
import {HttpRoot} from "./http/root.component";
import {RouterRoot} from "./router/root.component";
// import {AnimateRoot} from "./animate/root.component";
import {BrowserRoot} from "./browser/root.component";
import {I18nRoot} from "./i18n/root.component";

@Component({
  selector: "ng2-example",
  template: `
<div class="container">
  <md-toolbar>
    <span>Angular 2 Examples</span>
    <ul>
      <a [routerLink]="['CoreRoot']">Core</a>
      <a [routerLink]="['CommonRoot']">Common</a>
      <a [routerLink]="['HttpRoot']">Http</a>
      <a [routerLink]="['RouterRoot']">Router</a>
      <!--<a [routerLink]="['AnimateRoot']">Animate</a>-->
      <a [routerLink]="['BrowserRoot']">Browser</a>
      <!--<a [routerLink]="['I18nRoot']">I18n</a>-->
    </ul>
    <span class="md-toolbar-filler"></span>
    <a href="https://github.com/laco0416/angular2-example" target="_blank">GitHub</a>
  </md-toolbar>
  <div class="content">
    <router-outlet></router-outlet>
  </div>
</div>
  `,
  styles: [require("./app.css").toString()],
  providers: [
    Title,
    UseCaseSource
  ],
  directives: [MdToolbar]
})
@RouteConfig([
  { path: "/core/...", component: CoreRoot, name: "CoreRoot" },
  { path: "/common/...", component: CommonRoot, name: "CommonRoot" },
  { path: "/http/...", component: HttpRoot, name: "HttpRoot" },
  { path: "/router/...", component: RouterRoot, name: "RouterRoot" },
  // { path: "/animate/...", component: AnimateRoot, name: "AnimateRoot" },
  { path: "/browser/...", component: BrowserRoot, name: "BrowserRoot" },
  // { path: "/i18n/...", component: I18nRoot, name: "I18nRoot" },
  { path: '/*any', redirectTo: ['CoreRoot'] },
])
export class MyApp {
  constructor(private title: Title) {
  }

  ngOnInit() {
    this.title.setTitle("Angular2 Example (RC.1)")
  }
}

export function main(): Promise<ComponentRef<MyApp>> {
  if (!location.host.match(/localhost:8000/)) {
    enableProdMode();
  }
  return bootstrap(MyApp, [
    HTTP_PROVIDERS,
    ROUTER_PROVIDERS,
    provide(LocationStrategy, { useClass: HashLocationStrategy }),
    provide(PLATFORM_DIRECTIVES, {
      useValue: [
        UseCaseContainer,
        UseCaseContent,
        ModuleRoot
      ].concat(ROUTER_DIRECTIVES), multi: true
    }),
  ]);
}



/** WEBPACK FOOTER **
 ** ./script/app.ts
 **/